module.exports = __webpack_public_path__ + "static/media/4ODA7.1e215814.jpg";